import {
  GET_DOWNLOADS,
  SET_SEARCH
} from './types'

const initialState = {
  status: 'PENDING',
  list: [],
  search: '',
  total: 0
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SEARCH:
      return {
        ...state,
        search: action.payload.search
      }
    case GET_DOWNLOADS.PENDING:
      return {
        ...state,
        status: 'PENDING',
        list: []
      }
    case GET_DOWNLOADS.FULFILLED:
      return {
        ...state,
        status: state.search === action.payload.data.search ? 'COMPLETE' : state.status,
        list: state.search === action.payload.data.search ? action.payload.data.downloadJobs : state.list,
        total: state.search === action.payload.data.search ? action.payload.data.total : state.total
      }
    case GET_DOWNLOADS.FAILED:
      return {
        ...state,
        status: 'FAILED',
        list: []
      }
  default:
    return state
  }
}